import { Component, OnInit } from '@angular/core';
import { DBService } from '../../services/db.service';
import { Company } from '../../model/company';
import { Activity, ActivityCategory, ActivityStatus } from '../../model/activity';

import * as jsPDF from 'jspdf';

import * as html2canvas from 'html2canvas';
import { AuthenticationService } from '../../services/authentication.service';

declare var $: any;

@Component({
  selector: 'app-activities-report',
  templateUrl: './activities-report.component.html',
  styleUrls: ['./activities-report.component.css'],
  providers: [DBService, AuthenticationService]
})
export class ActivitiesReportComponent implements OnInit {

  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  initialDate: number;
  initialDateString: string;

  endDate: number;
  endDateString: string;

  companyFilter: string;

  companies: Company[];
  activities: Activity[];
  displayActivities: Activity[];

  items: ActivityReportItem[];

  loading: boolean;

  emptyData: boolean;

  userCompanyUID: string;

  constructor(private dbService: DBService, private authService: AuthenticationService) {
    this.companyFilter = '0';
    this.emptyData = true;

    if (!this.authService.isAdmin()) {
      this.userCompanyUID = this.authService.getUserCompany();
    }

    this.loadCompanies();
    this.loadActivities();
  }

  private loadCompanies() {
    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => {
        if (this.userCompanyUID) {
          this.companies = companies.filter(c => c.uid === this.userCompanyUID);
          this.companyFilter = this.userCompanyUID;
        } else {
          this.companies = companies;
        }
      });
  }

  private loadActivities() {
    this.dbService.listWithUIDs<Activity>('activities')
      .then(activities => this.activities = activities);
  }

  search() {
    this.emptyData = false;

    this.displayActivities = this.activities
      .filter(a => a.creationDate >= this.initialDate)
      .filter(a => a.creationDate <= this.endDate);

    if (this.companyFilter != '' && this.companyFilter != '0') {
      this.displayActivities = this.displayActivities.filter(a => a.companyUID == this.companyFilter);
    }

    this.initData();
  }

  private initData() {
    this.loading = true;


    this.items = [];
    this.initItem('group_work', 'Todas', null);
    this.initItem('email', 'E-mail', ActivityCategory.EMAIL);
    this.initItem('grade', 'Habilitação', ActivityCategory.HABILITATION);
    this.initItem('call', 'Ligação', ActivityCategory.CALL);
    this.initItem('gavel', 'Pregão', ActivityCategory.TRADING_FLOOR);
    this.initItem('speaker_notes', 'Proposta', ActivityCategory.PROPOSAL);
    this.initItem('group', 'Reunião', ActivityCategory.MEETING);
    this.initItem('place', 'Visita', ActivityCategory.VISIT);

    this.loading = false;
  }

  private initItem(icon: string, title: string, category: ActivityCategory) {
    const item = new ActivityReportItem();
    item.icon = icon;
    item.title = title;

    let filteredActivities = this.displayActivities;
    if (category != null) {
      filteredActivities = filteredActivities.filter(a => a.category == category);
    }

    item.total = filteredActivities.length;

    item.done = filteredActivities
    .filter(a => a.status == ActivityStatus.DONE)
    .filter(a => a.finishDate <= a.expirationDate)
    .length;

    item.pending = filteredActivities.filter(a => a.status != ActivityStatus.DONE ).length;

    item.problem = filteredActivities
    .filter(a => a.status == ActivityStatus.DONE)
    .filter(a => a.finishDate > a.expirationDate)
    .length;

    this.items.push(item);
  }

  ngOnInit() {
    $( function() {
      $( ".datePicker" ).datepicker({
        dateFormat: 'dd/mm/yy',
        dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S', 'D'],
        dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
        monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        nextText: 'Proximo',
        prevText: 'Anterior'
      });
    } );
  }


  async delay(ms: number) {
      await new Promise(resolve => setTimeout(()=>resolve(), ms));
  }

  onChangeStartDate(event) {

    this.delay(1000).then(any => {
    
      this.initialDateString = event.target.value;
      const dateParts = this.initialDateString.split('/');

      const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

      if (date.toString() === 'Invalid Date') {
        delete this.initialDate;
      } else {
        this.initialDate = date.getTime();
      }

    });

  }

  onChangeEndDate(event) {

    this.delay(1000).then(any => {

      this.endDateString = event.target.value;
      const dateParts = this.endDateString.split('/');

      const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

      if (date.toString() === 'Invalid Date') {
        delete this.endDate;
      } else {
        this.endDate = date.getTime();
      }

    });
    
  }

  exportPDF() {
    html2canvas(document.getElementById('content'), { width: 750, height: 915 }).then((canvas) => {
      const img = canvas.toDataURL('image/jpeg');
      const doc = new jsPDF('p', 'mm', 'a4');
      const width = doc.internal.pageSize.width;
      const height = doc.internal.pageSize.height;
      doc.addImage(canvas, 'JPEG', 0, 0, 208, 275);
      doc.save(`Relatório de Atividades.pdf`);
  });
  }
}

export class ActivityReportItem {
  icon: string;
  title: string;
  total: number;
  done: number;
  pending: number;
  problem: number;
}


// WEBPACK FOOTER //
// ./src/app/pages/activities-report/activities-report.component.ts